import { Component, Input, OnInit } from '@angular/core';
import { WindowRefService } from '@app/core';
import { size } from 'lodash';

@Component({
  selector: 'app-pay-ottu-form',
  templateUrl: './pay-ottu-form.component.html',
  styleUrls: ['./pay-ottu-form.component.scss']
})
export class PayOttuFormComponent implements OnInit {

  @Input() infoModePayement: Array<any>;
  val: number = null;
  constructor(private winRef: WindowRefService) { }

  ngOnInit() {
    console.log(this.infoModePayement, size(this.infoModePayement) >= 1);
    if (size(this.infoModePayement) >= 1) {
      this.val = 0; // Par défaut, sélectionnez le premier élément
    }
    console.log(this.val);
  }

  submit(val: number) {
    const selectedInfo = this.infoModePayement[this.val]; // Récupérez l'objet sélectionné
    console.log(val, selectedInfo);
    window.location.href = selectedInfo.action;
  }

  /**
   * get taux de change
   * @returns number
   */
  get Cpercente(): number {
    return this.winRef.appConfigSite.Cpercente;
  }

  /**
   * get currency
   * @returns string
   */
  get Ccurrency(): string {
    return this.winRef.appConfigSite.Ccurrency;
  }

}
